import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: 'info', message: 'Enviando mensaje...' });
    
    // Aquí irá la lógica para enviar el formulario
    // Por ahora, solo mostrar mensaje de éxito simulado
    setTimeout(() => {
      setStatus({ 
        type: 'success', 
        message: '¡Mensaje enviado! Te responderemos pronto.' 
      });
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 1500);
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contacto | Graphyra</title>
        <meta name="description" content="Contáctanos para consultas, soporte técnico o colaboraciones" />
      </Helmet>

      <div className="contact-container">
        <section className="contact-hero">
          <h1 className="contact-title">Contáctanos</h1>
          <p className="contact-subtitle">
            Estamos aquí para ayudarte. Envíanos un mensaje y te responderemos pronto.
          </p>
        </section>

        <div className="contact-content">
          <div className="contact-info-section">
            <div className="info-card">
              <div className="info-icon">📧</div>
              <h3>Correo Electrónico</h3>
              <div className="info-details">
                <div className="info-item">
                  <strong>Contacto General:</strong>
                  <a href="mailto:contact.graphyra@gmail.com">contact.graphyra@gmail.com</a>
                </div>
                <div className="info-item">
                  <strong>Soporte Técnico:</strong>
                  <a href="mailto:support.graphyra@gmail.com">support.graphyra@gmail.com</a>
                </div>
                <div className="info-item">
                  <strong>Administrativo:</strong>
                  <a href="mailto:admin.graphyra@gmail.com">admin.graphyra@gmail.com</a>
                </div>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📞</div>
              <h3>Teléfono</h3>
              <div className="info-details">
                <a href="tel:+573115491733" className="phone-number">+57 3115491733</a>
                <p className="phone-note">Línea corporativa</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">⏰</div>
              <h3>Horario de Atención</h3>
              <div className="info-details">
                <p><strong>Lunes a Viernes:</strong> 9:00 AM - 6:00 PM</p>
                <p><strong>Fines de semana:</strong> Respuestas por email</p>
                <p className="timezone-note">Zona horaria: COT (UTC-5)</p>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <div className="form-card">
              <h2>Envíanos un Mensaje</h2>
              <p className="form-description">
                Completa el formulario y te responderemos lo antes posible.
              </p>

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Nombre Completo *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Tu nombre"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Correo Electrónico *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="tu@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Asunto *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Selecciona un tema</option>
                    <option value="general">Consulta General</option>
                    <option value="support">Soporte Técnico</option>
                    <option value="content">Contenido / Colaboración</option>
                    <option value="press">Prensa</option>
                    <option value="business">Oportunidad de Negocio</option>
                    <option value="report">Reportar un Problema</option>
                    <option value="feedback">Sugerencia / Feedback</option>
                    <option value="other">Otro</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mensaje *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Cuéntanos en qué podemos ayudarte..."
                  ></textarea>
                </div>

                {status.message && (
                  <div className={`form-status ${status.type}`}>
                    {status.message}
                  </div>
                )}

                <button type="submit" className="submit-button">
                  Enviar Mensaje
                </button>
              </form>
            </div>
          </div>
        </div>

        <section className="faq-section">
          <h2>Preguntas Frecuentes</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>¿Cuánto tardan en responder?</h3>
              <p>
                Respondemos la mayoría de consultas dentro de 24-48 horas hábiles. 
                Consultas urgentes por teléfono pueden recibir respuesta más rápida.
              </p>
            </div>
            <div className="faq-item">
              <h3>¿Puedo colaborar con contenido?</h3>
              <p>
                ¡Absolutamente! Envíanos un correo a contact.graphyra@gmail.com con el asunto 
                "Colaboración de Contenido" y cuéntanos tu idea.
              </p>
            </div>
            <div className="faq-item">
              <h3>¿Cómo reporto un problema técnico?</h3>
              <p>
                Usa support.graphyra@gmail.com o el formulario con "Soporte Técnico" como asunto. 
                Incluye detalles del problema y pasos para reproducirlo.
              </p>
            </div>
            <div className="faq-item">
              <h3>¿Ofrecen publicidad o patrocinios?</h3>
              <p>
                Actualmente no ofrecemos espacios publicitarios. Para propuestas comerciales, 
                contáctanos en admin.graphyra@gmail.com.
              </p>
            </div>
          </div>
        </section>

        <section className="quick-links-section">
          <h2>Enlaces Rápidos</h2>
          <div className="quick-links-grid">
            <Link to="/about" className="quick-link-card">
              <div className="link-icon">ℹ️</div>
              <h3>Acerca de</h3>
              <p>Conoce nuestra historia y equipo</p>
            </Link>
            <Link to="/careers" className="quick-link-card">
              <div className="link-icon">💼</div>
              <h3>Trabaja con Nosotros</h3>
              <p>Oportunidades de colaboración</p>
            </Link>
            <Link to="/press" className="quick-link-card">
              <div className="link-icon">📰</div>
              <h3>Prensa</h3>
              <p>Información para medios</p>
            </Link>
            <Link to="/guidelines" className="quick-link-card">
              <div className="link-icon">📋</div>
              <h3>Normas</h3>
              <p>Guías de la comunidad</p>
            </Link>
          </div>
        </section>

        <div className="page-footer">
          <div className="footer-links">
            <Link to="/terms">Términos</Link>
            <span className="separator">•</span>
            <Link to="/privacy">Privacidad</Link>
            <span className="separator">•</span>
            <Link to="/">Volver al inicio</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
